import { AppState } from 'react-native';

let listener;
let currentState = '';

const onStateChange = (blogs, url, time, nextState) => {
    if (currentState.match(/active|inactive/) && nextState !== 'background') {
        blogs.stopLogging();
        blogs.logEvent({ time: Date.now(), type: 'general', subtype: 'standby' });
    } else if (currentState === 'background' && nextState !== 'active') {
        blogs.logEvent({ time: Date.now(), type: 'general', subtype: 'online' });
        blogs.startLogging(url, time);
    }
    currentState = nextState;
};

export const startAppStateLogger = (blogs, url, time) => {
    if (listener) {
        listener.remove();
    }
    listener = AppState.addEventListener('change', (nextAppState) =>
        onStateChange(blogs, url, time, nextAppState)
    );
};

export const LogBehavioralEvent = (appManager) => (params) => {
    const { blogs } = appManager.api.backstageConnector.events;
    blogs.logEvent({ ...params, time: Date.now() });
};
